import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'cboard.components.AuthScreenInformation.heading',
    defaultMessage: 'Cboard'
  },
  text: {
    id: 'cboard.components.AuthScreenInformation.text',
    defaultMessage: 'Sign up to sync your settings!'
  }
});
